<template>
  <div>
    <div class="item hole-header-background">{{ hole ? hole : '-' }}</div>

    <div :class="`item ${$vuetify.theme.dark ? '' : 'item-handicap'}`" v-if="holeHandicaps">
      {{ holeHandicaps[index] || '-' }}
    </div>

    <div class="item item-par" v-if="holePars">{{ holePars[index] || '-' }}</div>

    <!-- Scramble Team scores -->
    <div v-for="(i, x) in scrambleTeamsTotal" :key="`6${i}`">
      <transition name="fadeDown" mode="out-in" appear v-if="isScramble">
        <div
          :class="`item ${$vuetify.theme.dark ? '' : 'item-score'} ${checkScore(
            scrambleTeamScores[x].scores[index],
            holePars[index]
          )}`"
        >
          {{ scrambleTeamScores[x].scores[index] }}
        </div>
      </transition>
    </div>

    <!-- score -->
    <transition name="fadeDown" mode="out-in" appear v-if="!isScramble && !isBestBall">
      <div
        :key="holeScores[index]"
        :class="`item ${$vuetify.theme.dark ? '' : 'item-score'} ${checkScore(
          holeScores[index],
          holePars[index]
        )}`"
        v-if="holeScores"
      >
        {{ holeScores[index] | checkGrossScore }}
        <StablefordScoringDots
          v-if="holeStableFordTotals.length && holeStableFordTotals[index] > 0"
          :second="holeStableFordTotals[index] === 2"
          :third="holeStableFordTotals[index] === 3"
        />
      </div>
    </transition>

    <!-- net -->
    <transition name="fadeDown" mode="out-in" appear v-if="!isScramble && !isBestBall">
      <div
        :key="holeNetScores[index]"
        :class="`item ${$vuetify.theme.dark ? 'item-round-score' : 'item-round-score'}`"
        v-if="holeNetScores && hasNetScores"
      >
        {{ holeNetScores[index] }}
      </div>
    </transition>

    <!-- to par / round score / stableford points -->
    <transition name="fadeDown" mode="out-in" appear v-if="!isScramble && !isBestBall">
      <div class="item item-round-score" v-if="hasRoundScores && !hasStablefordScores">
        {{ holeRoundScores[index] | checkRoundScore }}
      </div>
      <div class="item item-round-score" v-else-if="hasStablefordScores">
        {{ stablefordScores[index] }}
      </div>
      <!-- <div class="item item-round-score" v-else></div> -->
    </transition>

    <!-- Best ball team scores -->
    <transition name="fadeDown" mode="out-in" appear v-if="hasBestBallTeamScores && !isScramble">
      <!-- <div class="item item-round-score" v-if="hasBestBallTeamScores"> -->
      <div
        :class="`item ${$vuetify.theme.dark ? '' : 'item-score'} ${checkScore(
          bestBallTeamScores[index],
          holePars[index]
        )}`"
        v-if="hasBestBallTeamScores"
      >
        {{ bestBallTeamScores[index] }}
      </div>
    </transition>

    <div class="item divider-header-background" v-if="teeClubs && !isScramble && !isBestBall">
      {{ teeClubs[index] }}
    </div>

    <transition name="fadeDown" mode="out-in" v-if="!isScramble && !isBestBall">
      <div class="item bullet" v-if="fairwayShots">
        {{ fairwayShots[index] ? '&bull;' : null }}
      </div>
    </transition>

    <div
      :class="['item', sandShots[index] ? 'sand-bullet' : 'no-sand']"
      v-if="sandShots && !isScramble && !isBestBall"
    >
      {{ sandShots[index] ? '&bull;' : '-' }}
    </div>

    <div
      :class="['item divider-header-background gir', greensInRegulation[index] ? '' : 'no-gir']"
      v-if="greensInRegulation && !isScramble && !isBestBall"
    >
      <transition name="fadeDown" mode="out-in">
        <v-icon>{{ greensInRegulation[index] ? 'golf_course' : 'golf_course' }}</v-icon>
      </transition>
    </div>

    <transition name="fadeDown" mode="out-in" v-if="!isScramble && !isBestBall">
      <div :class="['item item-putt']" v-if="puttingShots && expanded">
        {{ puttingShots[index] ? puttingShots[index] : '-' }}
      </div>
    </transition>

    <transition name="fadeDown" mode="out-in" v-if="!isScramble && !isBestBall">
      <div :class="['item']" v-if="mulligans && expanded">
        {{ mulligans[index] ? mulligans[index] : '-' }}
      </div>
    </transition>

    <transition name="fadeDown" mode="out-in" v-if="!isScramble && !isBestBall">
      <div :class="['item']" v-if="penalties && expanded">
        {{ penalties[index] ? penalties[index] : '-' }}
      </div>
    </transition>
  </div>
</template>

<script>
import StablefordScoringDots from '@/components/StablefordScoringDots';
import utilityMixin from '@/mixins/utilityMixin';

export default {
  name: 'ScoreCardItem',
  mixins: [utilityMixin],
  props: {
    userShotData: Object,
    hole: Number,
    index: Number,
    expanded: Boolean,
    gameMode: String,
  },

  components: {
    StablefordScoringDots,
  },

  computed: {
    holeHandicaps() {
      if (this.utility_isObject(this.userShotData)) {
        const { holeHandicaps } = this.userShotData || {};
        return holeHandicaps ?? [];
      }
      return [];
    },

    holePars() {
      if (this.utility_isObject(this.userShotData)) {
        const { holePars } = this.userShotData || {};
        return holePars ?? [];
      }
      return [];
    },

    holeScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { holeScores } = this.userShotData || {};
        return holeScores ?? [];
      }
      return [];
    },

    holeRoundScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { holeRoundScores } = this.userShotData || {};
        return holeRoundScores ?? [];
      }
      return [];
    },

    holeNetScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { holeNetScores } = this.userShotData || {};
        return holeNetScores ?? [];
      }
      return [];
    },

    holeStableFordTotals() {
      if (this.utility_isObject(this.userShotData)) {
        const { holeStableFordTotals } = this.userShotData || {};
        return holeStableFordTotals ?? [];
      }
      return [];
    },

    stablefordScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { stablefordScores } = this.userShotData || {};
        return stablefordScores ?? [];
      }
      return [];
    },

    bestBallTeamScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { bestBallTeamScores } = this.userShotData || {};
        return bestBallTeamScores ?? [];
      }
      return [];
    },

    teeClubs() {
      if (this.utility_isObject(this.userShotData)) {
        const { teeClubs } = this.userShotData || {};
        return teeClubs ?? [];
      }
      return [];
    },

    fairwayShots() {
      if (this.utility_isObject(this.userShotData)) {
        const { fairwayShots } = this.userShotData || {};
        return fairwayShots ?? [];
      }
      return [];
    },

    sandShots() {
      if (this.utility_isObject(this.userShotData)) {
        const { sandShots } = this.userShotData || {};
        return sandShots ?? [];
      }
      return [];
    },

    greensInRegulation() {
      if (this.utility_isObject(this.userShotData)) {
        const { greensInRegulation } = this.userShotData || {};
        return greensInRegulation ?? [];
      }
      return [];
    },

    puttingShots() {
      if (this.utility_isObject(this.userShotData)) {
        const { puttingShots } = this.userShotData || {};
        return puttingShots ?? [];
      }
      return [];
    },

    mulligans() {
      if (this.utility_isObject(this.userShotData)) {
        const { mulligans } = this.userShotData || {};
        return mulligans ?? [];
      }
      return [];
    },

    penalties() {
      if (this.utility_isObject(this.userShotData)) {
        const { penalties } = this.userShotData || {};
        return penalties ?? [];
      }
      return [];
    },

    hasNetScores() {
      if (this.utility_isObject(this.userShotData)) {
        const hasNetScoreValue = this.userShotData?.holeNetScores.some((value) => {
          return value !== null && value !== undefined;
        });
        return hasNetScoreValue;
      }
      return false;
    },

    hasRoundScores() {
      if (this.utility_isObject(this.userShotData)) {
        // const { holeRoundScores } = this.userShotData;
        // return holeRoundScores?.length > 0;

        const hasRoundScoreValue = this.userShotData?.holeRoundScores.some((value) => {
          return value !== null && value !== undefined;
        });
        return hasRoundScoreValue;
      }
      return false;
    },

    hasStablefordScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { stablefordScores } = this.userShotData;
        const isAllNull = this.checkAllNull(stablefordScores);
        return !isAllNull && stablefordScores?.length > 0;
      }
      return false;
    },

    isBestBall() {
      return this.gameMode?.toLowerCase().replace('_', '') === 'bestball';
    },

    hasBestBallTeamScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { bestBallTeamScores } = this.userShotData;
        const isAllNull = this.checkAllNull(bestBallTeamScores);
        return !isAllNull && bestBallTeamScores?.length > 0;
      }
      return false;
    },

    isScramble() {
      return this.gameMode?.toLowerCase() === 'scramble';
    },

    scrambleTeamsTotal() {
      if (this.utility_isObject(this.userShotData)) {
        return this.userShotData?.scrambleTeamScores?.length;
      }
      return [];
    },

    scrambleTeamScores() {
      if (this.utility_isObject(this.userShotData)) {
        const { scrambleTeamScores } = this.userShotData;
        return scrambleTeamScores;
      }
      return [];
    },
  },

  methods: {
    checkAllNull(data) {
      const isAllNull = data?.every((item) => {
        return item === null;
      });
      return isAllNull;
    },

    checkScore(score, par) {
      const range = score - par;
      if (score === null || par === null) {
        return '';
      }

      if (score !== null) {
        switch (range) {
          case 0:
            return 'par';
          case -1:
            return 'birdie';
          case -2:
            return 'eagle';
          case -3:
            return 'under-eagle';
          case -4:
            return 'under-eagle';
          case 1:
            return 'bogey';
          case 2:
            return 'double-bogey';
          case 3:
            return 'triple-bogey';
          default:
            return 'over-bogey';
        }
      }
      return '';
    },
  },

  filters: {
    checkRoundScore(s) {
      if (s === null) {
        return ``;
      }
      if (typeof s === 'string') {
        return s;
      }

      const sign = Math.sign(s);
      switch (sign) {
        case 0:
          return 'E';
        case 1:
          return `+${s.toFixed(0)}`;
        case -1:
          return `${s.toFixed(0)}`;
        default:
          break;
      }
    },

    checkGrossScore(s) {
      if (s === null || s === undefined) {
        return;
      }
      return s.toFixed(0);
    },
  },
};
</script>

<style scoped>
.item {
  padding: 16px 8px;
  text-align: center;
  width: 100%;
  line-height: 0;
  position: relative;
}

.item-score {
  background-color: var(--offWhite, #efefef);
}

.item-putt,
.item-par {
  border-bottom: 1px solid #6d6d6d;
  border-bottom: 1px solid var(--grey, #828282);
}

.item-round-score {
  border-top: 1px solid #6d6d6d;
  border-top: 1px solid var(--grey, #828282);
}

.item-handicap {
  background-color: var(--offWhite, #efefef);
}

.hole-header-background {
  background-color: var(--grey, #828282);
  color: var(--white, #ffffff);
}

.divider-header-background {
  background-color: var(--grey-light, #95989b);
  color: var(--white, #ffffff);
}
.theme--dark .par:not(.theme-light) {
  background-color: var(--grey-themeDark, #424242);
  color: var(--white, #ffffff);
}

.par,
.theme--light .par:not(.theme--dark) {
  background-color: var(--offWhite, #efefef);
  color: var(--offBlack, #222222);
}

.birdie {
  background-color: var(--primary, #ba2127);
  color: var(--white, #ffffff);
}

.eagle,
.under-eagle {
  background-color: var(--yellow, #ffcc00);
  color: var(--offBlack, #222222);
}

.double-eagle {
  background-color: var(--green, #67a011);
  color: var(--white, #ffffff);
}

.in-play {
  background-color: var(--orange-lightest, #ffc199);
  color: var(--offBlack, #222222);
}

.bogey {
  background-color: var(--blue, #5995c7);
  color: var(--white, #ffffff);
}

.double-bogey {
  background-color: var(--grey, #828282);
  color: var(--white, #ffffff);
}

.triple-bogey,
.over-bogey {
  background-color: var(--grey-darker, #3e3e3e);
  color: var(--white, #ffffff);
}

.bad {
  background-color: var(--black, #000000);
  color: var(--white, #ffffff);
}

.over {
  background-color: #f7b90d;
}

.under {
  background-color: #69abde;
}

.bullet {
  font-size: 4.375rem;
  color: var(--green, #67a011);
  padding: 16px 0;
  line-height: 0;
}

.sand-bullet {
  font-size: 3.5rem;
  color: #6d6d6d;
  color: var(--grey, #828282);
  padding: 16px 0;
  line-height: 0;
}

.gir {
  padding: 5px 0;
}

.gir > i {
  min-height: 22px;
  font-size: 0.75rem;
  padding: 0 5px;
  border-radius: 50%;
  background-color: var(--green, #67a011);
  color: var(--white);
}

.no-gir > i {
  color: var(--grey-alt, #aaabad);
  background-color: var(--grey-lighter, #a6a7a9);
}

@media screen and (max-width: 960px) {
  .item {
    padding: 8px;
  }

  .gir {
    padding: 0;
  }

  .gir > i {
    font-size: 0.5rem;
    padding: 4px;
    min-height: 10px;
    max-height: 16px;
  }

  .bullet {
    font-size: 2.625rem;
  }

  .sand-bullet {
    font-size: 1.75rem;
  }
}
</style>
